import { render, staticRenderFns } from "./Imglazy.vue?vue&type=template&id=280b7ad6&scoped=true&"
import script from "./Imglazy.vue?vue&type=script&lang=js&"
export * from "./Imglazy.vue?vue&type=script&lang=js&"
import style0 from "./Imglazy.vue?vue&type=style&index=0&id=280b7ad6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280b7ad6",
  null
  
)

export default component.exports